import { ButtonAnchor } from '../components/common'
import styles from './NotFoundPage.module.scss'

export default function NotFoundPage() {
  return (
    <div className={`${styles.notFoundPage} layout-no-leftnav`}>
      <section className="login-section auth-section">
        <div className="container">
          <div className="row">
            <div className="form-box col-md-8 col-sm-12 col-xs-12 col-md-offset-2 col-sm-offset-0 xs-offset-0">
              <h1 className="form-box-heading logo text-center">
                <span className="pe-icon pe-7s-box2 icon">
                  <span className="highlight">Historia Clínica</span>
                </span>
              </h1>
              <div className="jumbotron text-center error-500">
                <h1>404</h1>
                <p>Página no encontrada</p>
                <p className="little-font">Para comunicarte con el equipo de soporte, envíanos un correo a contacto@historiaclinica.cl</p>
                <div className="action">
                  <ButtonAnchor
                    href="#"
                    id="back-button"
                    onClick={(event) => {
                      event.preventDefault()
                      window.history.back()
                    }}
                  >
                    Atras
                  </ButtonAnchor>
                  <ButtonAnchor href="/">Volver a página principal</ButtonAnchor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
